import { apiInfo, fetchRequest, HTTPMethod, Resource } from './api';

export const getTransversalResources = () => {
    return fetchRequest(HTTPMethod.GET, `${apiInfo.base}/${Resource.TRANSVERSAL_RESOURCES}`);
};
